module.exports = __webpack_public_path__ + "img/icon-info-black.426868a7.svg";